import styled from 'styled-components';
import { colors } from "colors";
import { ReactComponent as accessIcon } from "assets/svgs/browser.svg";

export const Wrapper = styled.div`
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const AccessIcon = styled(accessIcon)`
    width: 100px;
    height: 100px;
`;

export const Heading = styled.h1`
    margin: 10px 0;
`;

export const SubText = styled.p`
    margin: 0;
    color: ${colors.slateGrey};
`;